import React from 'react'
import { Button, message, Upload } from 'antd'
import { useService } from '@hooks'
import { getSDRIntentionLeadUploadPath, getSDRIntentionLeadDownloadPath, uploadSDRWeWorkLead } from '@services/lead'
import downloadByATag from 'src/library/downloadByATag'
import { cosPutObject } from 'src/library/cosUtils'

export default function BatchAdd () {
  const [, pathPrefix, err] = useService(getSDRIntentionLeadUploadPath)
  console.log('pathPrefix', pathPrefix)

  if (err) {
    message.error(`获取上传路径失败: (${err.message})`)
  }

  const downloadUploadTemplate = async () => {
    const [url, err] = await getSDRIntentionLeadDownloadPath()
    if (err) {
      message.error(`下载失败: ${err.message}`)
    } else {
      downloadByATag('企微孵化线索模板.xlsx', url?.file)
    }
  }

  const customRequest = async (options) => {
    const { file } = options
    const [, err] = await cosPutObject(file, undefined, `${pathPrefix?.path}/${file?.name}`)
    if (err) {
      message.error(`上传失败: ${err.message}`)
    } else {
      const [, uploadErr] = await uploadSDRWeWorkLead({ file: `${pathPrefix?.path}/${file?.name}` })
      if (uploadErr) {
        message.error(`上传失败: ${uploadErr.message}`)
      } else {
        message.success('上传成功')
      }
    }
  }
  return (
    <>
      <div>
        <div style={{ marginBottom: 10 }}>请选择上传的excel文件:
          <Upload
            accept=".xls,.xlsx"
            customRequest={customRequest}
            itemRender={() => null}
          >
            <Button type="primary">上传文件</Button>
          </Upload>
        </div>
        <div>
          注: 文件需符合格式要求<Button type="link" onClick={() => downloadUploadTemplate()}>下载模板</Button>
        </div>
        {/* <label htmlFor="file">
          <input type="file" id="file" onChange={customRequest} style={{ display: 'none' }} />
          <Button type="primary" onClick={() => document.getElementById('file')?.click()}>上传文件</Button>
        </label> */}
        {/* <CosUpload size={10} accept=".xls,.xlsx" pathPrefix={pathPrefix?.path} onChange={handleChange} /> */}
      </div>
    </>
  )
}
